import * as yup from 'yup';
import {
  AddressDataSchema,
  CommunicationDataSchema,
  HealthInsuranceInputSchema,
  HealthInsuranceSchema,
  IAddressData,
  ICommunicationData,
  IHealthInsurance,
  IHealthInsuranceInput,
  UpdateAddressDataSchema,
  UpdateCommunicationDataSchema,
} from '../../../common';
import {
  IPersonalData,
  PersonalDataSchema,
  UpdatePersonalDataSchema,
} from '../../employee-creation';

export const ResidentBaseDataSchema = yup.object({
  personalData: PersonalDataSchema.notRequired(),
  currentAddress: AddressDataSchema.notRequired(),
  communication: CommunicationDataSchema.notRequired(),
  oldAddress: AddressDataSchema.notRequired(),
  healthInsurance: HealthInsuranceSchema.notRequired(),
  remark: yup.string().notRequired().nullable(),
});

export interface IResidentBaseData {
  personalData?: IPersonalData;
  currentAddress?: IAddressData;
  communication?: ICommunicationData;
  oldAddress?: IAddressData;
  healthInsurance?: IHealthInsurance;
  remark?: string;
}

export interface ICreateResidentBaseData {
  personalData?: IPersonalData;
  currentAddress?: IAddressData;
  communication?: ICommunicationData;
  oldAddress?: IAddressData;
  healthInsurance?: IHealthInsuranceInput;
  remark?: string;
}

export const UpdateResidentBaseDataSchema = yup.object({
  id: yup.string().required(),
  personalData: UpdatePersonalDataSchema.optional().default(undefined),
  currentAddress: UpdateAddressDataSchema.optional().default(undefined),
  communication: UpdateCommunicationDataSchema.optional().default(undefined),
  oldAddress: UpdateAddressDataSchema.optional().default(undefined),
  healthInsurance: HealthInsuranceInputSchema.optional().default(undefined),
  remark: yup.string().notRequired().nullable().default(null),
});

export interface IUpdateResidentBaseData {
  id: string;
  personalData?: IPersonalData;
  currentAddress?: IAddressData;
  communication?: ICommunicationData;
  oldAddress?: IAddressData;
  healthInsurance?: IHealthInsuranceInput;
  remark?: string;
}
